export const FREIGHT_VALIDITY_STATUS = {
  PENDENTE: 1,
  APROVADA: 2,
  CANCELADA: 3,
};

export const FREIGHT_VALIDITY_TABS = [
  { value: FREIGHT_VALIDITY_STATUS.PENDENTE, label: "Pendentes" },
  { value: FREIGHT_VALIDITY_STATUS.APROVADA, label: "Aprovadas" },
  { value: FREIGHT_VALIDITY_STATUS.CANCELADA, label: "Canceladas" },
];

export const FREIGHT_VALIDITY_STATUS_FILTER = {
  ALL: "ALL",
  PENDING_APPROVAL: "PENDING_APPROVAL",
  APPROVED: "APPROVED",
  REJECTED: "REJECTED",
};

export const FREIGHT_VALIDITY_STATUS_FILTER_OPTIONS = [
  { value: FREIGHT_VALIDITY_STATUS_FILTER.ALL, label: "Todas" },
  {
    value: FREIGHT_VALIDITY_STATUS_FILTER.PENDING_APPROVAL,
    label: "Pendente",
  },
  { value: FREIGHT_VALIDITY_STATUS_FILTER.APPROVED, label: "Aprovada" },
  { value: FREIGHT_VALIDITY_STATUS_FILTER.REJECTED, label: "Reprovada" },
];
